import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './ActionBarStrip.scss';

export interface Props {
  className?: string;
  children: React.ReactNode;
}

const ActionBarStrip = forwardRef<HTMLDivElement, Props>(({ className, children }, ref) => {
  const { t } = useTranslation();
  return (
    <Section className={classnames(s['root'], className)} ref={ref}>
      <VisuallyHidden>
        <Heading>{t('actionbar.a11y.heading')}</Heading>
      </VisuallyHidden>
      {children}
    </Section>
  );
});
ActionBarStrip.displayName = 'ActionBarStrip';

export default ActionBarStrip;
